"use client";
import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "@repo/utils/utils";
const Popover = PopoverPrimitive.Root;
const PopoverClose = PopoverPrimitive.Close;
const PopoverTrigger = PopoverPrimitive.Trigger;
/**
 * Default portal container for every `PopoverContent` rendered beneath a provider.
 * Set this to a node *inside* a modal Radix Dialog so popovers portal into the
 * dialog's interactive subtree instead of `<body>` (which a modal marks
 * `pointer-events: none`, dismissing portaled popovers on click). An explicit
 * `container` prop or `noPortal` still wins over the context value.
 */
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverContainerContext = React.createContext(undefined);
const PopoverContent = React.forwardRef(({ className, align = "center", sideOffset = 4, noPortal, container, ...props }, ref) => {
    const ctxContainer = React.useContext(PopoverContainerContext);
    const resolvedContainer = container ?? ctxContainer;
    const content = (<PopoverPrimitive.Content ref={ref} align={align} sideOffset={sideOffset} className={cn("z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)} {...props}/>);
    return noPortal ? (content) : (<PopoverPrimitive.Portal container={resolvedContainer}>{content}</PopoverPrimitive.Portal>);
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent, PopoverClose, PopoverContainerContext, };
